import actionTypes from '../constants/action-types';

const setUpdatedAt = (value) => ({
  type: actionTypes.SET_UPDATED_AT,
  payload: {
    value,
  },
});

export default setUpdatedAt;
